// extracted by mini-css-extract-plugin
module.exports = {"banner-swiper":"CategorySwiper_banner-swiper__sULS_","detail-swiper":"CategorySwiper_detail-swiper__IFb1h","row-of-two":"CategorySwiper_row-of-two__9uEEz"};